/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var Backbone = require('backbone');
var Radio = require('backbone.radio');
var Marionette = require('backbone.marionette');

var UIUtil = require('psa-core/util/ui');

var modelGet = require('common/util/modelGet');
var SideNavSectionView = require('common/views/SideNavSectionView');
var BreadcrumbView = require('common/views/BreadcrumbView');
var DropdownView = require('common/views/DropdownView');

var DepEntitySelectFilingTypeModalView = require('./DepEntitySelectFilingTypeModalView');
var DepExtEntityPendingTasksView = require('./DepExtEntityPendingTasksView');

var GetAllFilingLookups = require('../../common/services/GetAllFilingLookups');

var tmplDepExtEntityDashboardView = require('../templates/DepExtEntityDashboardView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplDepExtEntityDashboardView,

  className: 'dep-ext-entity-dashboard-view container-fluid m-b-lg',

  behaviors: {
    ReadOnlyFormBehavior: {}
  },

  ui: {
    entityWrapper: '.entity-wrapper',
    entityActionDropDown: '.dropdown-container',
    breadcrumb: '.breadcrumb-container'
  },

  regions: {
    entityWrapper: '@ui.entityWrapper',
    entityActionDropDown: '@ui.entityActionDropDown',
    breadcrumb: '@ui.breadcrumb'
  },

  onBeforeShow: function() {
    var self = this;

    var entityId = this.model.get('entityId');
    var entityName = modelGet(this.model, 'entityIdentifiers.entityName');
    var charterTypeId = modelGet(this.model, 'entityIdentifiers.charterTypeId');
    var categoryId = modelGet(this.model, 'entityIdentifiers.categoryId');
    var isCollectiveInvestmentFund = modelGet(this.model, 'entityIdentifiers.isCollectiveInvestmentFund');

    var userAccessLevelId = +this.model.get('accessLevelId');
    var isLawyerUser = userAccessLevelId === 1;

    var viewMode = this.options.viewMode;

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#ext/dep/dashboard',
            text: 'Home'
          },
          {
            text: entityName
          }
        ]
      })
    );

    if (userAccessLevelId >= 20 || isLawyerUser) {
      var dropDownOptions = [
        {
          text: 'Submit Filing',
          onClick: function() {
            self.displaySubmitFilingOptions(categoryId);
          }
        }
      ];

      this.showChildView(
        'entityActionDropDown',
        new DropdownView({
          rightAlign: true,
          model: new Backbone.Model({
            name: 'Entity Actions',
            options: dropDownOptions
          })
        })
      );
    }

    var sideNavTabs = [
      {
        id: 'pendingTasks',
        title: 'Pending Tasks',
        view: new DepExtEntityPendingTasksView({
          model: new Backbone.Model({
            tasks: this.model.get('tasks')
          })
        })
      },
      {
        id: 'activeFilings',
        title: 'Active Filings',
        view: Radio.channel('dp').request('build:ext-active-filings-section-view', {
          entityId: entityId,
          userAccessLevelId: userAccessLevelId
        })
      },
      {
        id: 'locations',
        title: 'Locations',
        view: Radio.channel('dp').request('build:ext-entity-location-view', entityId)
      }
    ];

    // CIF/CTF available for 1. Trust, charter type Trust Company only
    // 2. Bank, charter types Bank and Trust, Savings Bank with Trust
    var entityCharterTypeHasCIF = ['2', '21', '31'];
    var entityHasCIFs = _.contains(entityCharterTypeHasCIF, charterTypeId);
    var showCIF = isCollectiveInvestmentFund === '1' && entityHasCIFs && !isLawyerUser;
    if (showCIF) {
      sideNavTabs.splice(2, 0, {
        id: 'funds',
        title: 'Funds',
        view: Radio.channel('dp').request('build:ext-entity-fund-view', entityId)
      });
    }

    if (userAccessLevelId >= 30) {
      sideNavTabs.push({
        id: 'userManagement',
        title: 'User Management',
        view: Radio.channel('dp').request('build:user-management-section-view', entityId, viewMode)
      });
    }

    this.entity = new SideNavSectionView({
      collection: new Backbone.Collection(sideNavTabs)
    });

    this.showChildView('entityWrapper', this.entity);
  },

  displaySubmitFilingOptions: function(categoryID) {
    var entityId = this.model.get('entityId');
    var entityIdentifiers = this.model.get('entityIdentifiers');
    $.when(GetAllFilingLookups()).done(function(lookups) {
      var filingTypes = _.chain(lookups.filingTypes)
        .filter(function(lookup) {
          return lookup.categoryId === categoryID && lookup.isExternallyVisible;
        })
        .value();
      UIUtil.showModal({
        title: 'Submit Filing - Select Filing Type',
        view: new DepEntitySelectFilingTypeModalView({
          model: new Backbone.Model({
            filingTypes: filingTypes,
            entityId: entityId,
            entityIdentifiers: entityIdentifiers,
            isExternalFiling: '1'
          })
        })
      }).done(function(response) {
        Radio.channel('navigate').trigger('show:ext:dp:draft-filing', response.filingId);
      });
    });
  }
});
